import { runAiInference } from '../../api/aiInference';
import { addTask } from '../../services/taskResolver';

export function extractGenerateMaskPolygonList(data) {
  if (data == null) return [];
  const tr = data.taskResult;
  if (Array.isArray(tr)) return tr;
  if (Array.isArray(data.polygons)) return data.polygons;
  if (Array.isArray(data)) return data;
  return [];
}

/**
 * Run generate_mask for a room image and return the detected interior list.
 * @param {number} roomImageId
 * @returns {Promise<Array>}
 */
export async function runGenerateMaskForRoomImage(roomImageId) {
  const res = await runAiInference({
    task_name: 'generate_mask',
    room_image_id: Number(roomImageId),
    labels: [],
  });

  const immediate = extractGenerateMaskPolygonList(res);
  if (immediate.length > 0) return immediate;

  const taskId = res?.taskId ?? res?.aiTaskId ?? res?.id;
  if (taskId == null) return [];

  const data = await new Promise((resolve, reject) => {
    addTask(taskId, {
      roomImageId,
      onResolve: resolve,
      onError: reject,
    });
  });

  return extractGenerateMaskPolygonList(data);
}
